<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Balance requests</h1>

		<Loader v-if="soft_loading" :soft="true" />

		<Table class="margin-top" :columns="columns" :rows="records" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    soft_loading: false,
    loading: false,
    records: [],
    columns: {
      id: {},
      order: {},
      created_at: {},
      process_attempted_at: {},
      processed_at: {},
      delay_until: {}
    }
  }),
  methods: {
    load () {
      Vue.api.get('/balance-requests', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: data => this.parse(data)
      })
    },
    balanceUniconta (orderId) {
      if (!confirm('Are you sure?')) {
        return
      }
      Vue.api.post('/balance-requests/order/' + orderId + '/balance', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.$router.go()
      })
    },
    markAsProcessed (orderId) {
      if (!confirm('Are you sure?')) {
        return
      }
      Vue.api.post('/balance-requests/order/' + orderId + '/mark-as-balanced', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.$router.go()
      })
    },
    parse (data) {
      this.records = data.map(row => {
        row.order = {
          type: 'order-link',
          order_id: row.order_id
        }

        row.menu = [
          {
            name: 'Balance',
            onClick: row => {
              this.balanceUniconta(row.order_id)
            }
          },
          {
            name: 'Mark as processed',
            onClick: row => {
              this.markAsProcessed(row.order_id)
            }
          }
        ]

        return row
      })
    }
  },
  created () {
    this.load()

    Vue.$ui.setTitle('Balance requests')
  }
}
</script>
